import React from 'react';
import { Container } from 'reactstrap';
import UsersTable from './components/UsersTable';
import StandardLayout from '@/common/layouts/StandardLayout';

const UsersPage: React.FC = () => {
  return (
    <StandardLayout pageTitle="Users">
      <Container fluid>
        <UsersTable />
      </Container>
    </StandardLayout>
  );
};

export default UsersPage;
